module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/main-fdd0cb7e0068d9c9a8ee59a1cf61f8ef.jpg";